import { GET, POST, PUT, DELETE } from "./common/http";
import { BASE_URL } from "./common/const";

export const CreateNote = (data: any) => POST(`${BASE_URL}/notes/create`, data);

export const UpdateNote = (data: any) => PUT(`${BASE_URL}/notes/update`, data);

export const GetNoteDetail = (params: any) =>
  GET(`${BASE_URL}/notes/detail?` + params, null);

export const GetNoteList = (params: any) =>
  GET(`${BASE_URL}/notes/list?` + params, null);

export const DeleteNote = (data: any) => PUT(`${BASE_URL}/notes/delete`, data);
